import { combineReducers, Reducer } from "redux";
import {
  LOAD_APPLICATION_NOTIFICATIONS_SUCCESS,
  NotificationAction,
  REMOVE_ALERT,
  SHOW_ALERT,
  UPDATE_APPLICATION_NOTIFICATIONS_SUCCESS,
  UPDATE_FINANCE_QUOTE_CALC_ERRORS_SUCCESS,
  UPDATE_FINANCE_QUOTE_ERRORS_SUCCESS, UPDATE_LEASE_QUOTE_CALC_ERRORS_SUCCESS, UPDATE_LEASE_QUOTE_ERRORS_SUCCESS,
} from "./actions";
import { IRuleViolation } from "../../Interfaces/Application/IApplicationQuote";
import { Alert } from "../../Data/Alert";
import { any, append, reject } from "ramda";
import {BrowserNotification} from "@amsanalytics/react-shared-library/build/Models/BrowserNotification";

export interface INotificationsState {
  leaseQuoteErrors: IRuleViolation[];
  leaseQuoteCalcErrors: string[];
  financeQuoteErrors: IRuleViolation[];
  financeQuoteCalcErrors: string[]; // Used when running the calculator, not for when the business rules run (like with financeQuoteErrors)
  browserNotifications: BrowserNotification[];
  notifications: Alert[]; // errors, warnings to display to the user
}

export const INITIAL_STATE: INotificationsState = {
  leaseQuoteErrors: [],
  leaseQuoteCalcErrors: [],
  financeQuoteErrors: [],
  financeQuoteCalcErrors: [],
  browserNotifications: [],
  notifications: []
}

const leaseQuoteErrorsReducer = (state: IRuleViolation[] = INITIAL_STATE.leaseQuoteErrors, action: NotificationAction): IRuleViolation[] => {
  switch (action.type) {
    case UPDATE_LEASE_QUOTE_ERRORS_SUCCESS:
      return action.payload.leaseQuoteErrors;
    default:
      return state;
  }
};

const leaseQuoteCalcErrorsReducer = (state: string[] = INITIAL_STATE.leaseQuoteCalcErrors, action: NotificationAction): string[] => {
  switch (action.type) {
    case UPDATE_LEASE_QUOTE_CALC_ERRORS_SUCCESS:
      return action.payload.leaseQuoteCalcErrors;
    default:
      return state;
  }
};

const financeQuoteErrorsReducer = (state: IRuleViolation[] = INITIAL_STATE.financeQuoteErrors, action: NotificationAction): IRuleViolation[] => {
  switch (action.type) {
    case UPDATE_FINANCE_QUOTE_ERRORS_SUCCESS:
      return action.payload.financeQuoteErrors;
    default:
      return state;
  }
};

const financeQuoteCalcErrorsReducer = (state: string[] = INITIAL_STATE.financeQuoteCalcErrors, action: NotificationAction): string[] => {
  switch (action.type) {
    case UPDATE_FINANCE_QUOTE_CALC_ERRORS_SUCCESS:
      return action.payload.financeQuoteCalcErrors;
    default:
      return state;
  }
};

const applicationNotificationsReducer = (state: BrowserNotification[] = INITIAL_STATE.browserNotifications, action: NotificationAction): BrowserNotification[] => {
  switch (action.type) {
    case LOAD_APPLICATION_NOTIFICATIONS_SUCCESS:
    case UPDATE_APPLICATION_NOTIFICATIONS_SUCCESS:
      return action.payload.browserNotifications;
    default:
      return state;
  }
};

const notificationsReducer = (state: Alert[] = INITIAL_STATE.notifications, action: NotificationAction): Alert[] => {
  switch (action.type) {
    case SHOW_ALERT:
      if (!any(a => a.message === action.payload.notification.message && a.type === action.payload.notification.type, state)
        && action.payload.notification.message.toLowerCase() !== "cannot read property 'accessToken' of undefined"
        && action.payload.notification.message.toLowerCase() !== "cannot read property 'json' of undefined"
        && action.payload.notification.message.toLowerCase() !== 'unexpected end of json input'
        && action.payload.notification.message.toLowerCase() !== 'unexpected token s in json at position 0'
        && action.payload.notification.message.toLowerCase() !== 'unexpected token m in json at position 0'
      ) {
        return append(action.payload.notification, state);
      }
      return state;
    case REMOVE_ALERT:
      return reject((n: Alert) => n.id === action.payload.notificationId, state);
    default:
      return state;
  }
};


export const notificationReducer: Reducer<INotificationsState> = combineReducers<INotificationsState>({
  leaseQuoteErrors: leaseQuoteErrorsReducer,
  leaseQuoteCalcErrors: leaseQuoteCalcErrorsReducer,
  financeQuoteErrors: financeQuoteErrorsReducer,
  financeQuoteCalcErrors: financeQuoteCalcErrorsReducer,
  browserNotifications: applicationNotificationsReducer,
  notifications: notificationsReducer
});